import { useSelector } from "react-redux";
import LinkWrap from "../../../../components/LinkWrap/component";
import { getSponsorLabel } from "../../../../utils/sponsor/library";
import { isValidString } from "../../../../utils/content/library";

const SponsorBy = () => {
    const sponsorBio = useSelector((state) => state.detail.content.sponsorBio);

    if (!sponsorBio || Object.keys(sponsorBio).length === 0) return null;

    const sponsorLabel = getSponsorLabel(sponsorBio.label);
    const logo = sponsorBio.image?.aspects?.ratioCustom?.url
        ? `${sponsorBio.image.aspects.ratioCustom.url}Resize%2Cheight%3D90`
        : "";
    const enableLink = isValidString(sponsorBio.link);

    let sponsorBy = (
        <span className="sponsorLogo">
            {sponsorLabel}{" "}
            <img src={logo} alt={sponsorBio.name} loading="lazy" />
        </span>
    );

    sponsorBy = enableLink ? (
        <LinkWrap
            url={sponsorBio.link}
            external={true}
            className="sponsorLink"
            target="_blank"
        >
            {sponsorBy}
        </LinkWrap>
    ) : (
        sponsorBy
    );

    return (
        <div className="sponsorBy" data-testid="sponsor-by">
            {sponsorBy}
        </div>
    );
};

export default SponsorBy;
